import { InvoiceAddressKeys } from "@ews/react-data";
import Icon from "@ews/react-icons";
import { useL10n } from "@ews/react-localization-context";
import { IonCardContent, IonCardHeader, IonContent, IonGrid, IonItem, IonModal, IonRow, IonTitle } from "@ionic/react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useIsMobile } from "../../../../../Responsive";
import style from "../../LicenseSettings.module.scss";
import { breakpoint, getContentMaxHeight, hasRequiredFields } from "../../helper";
import { ButtonContainer } from "./ButtonContainer";
import { Content } from "./Content";
import { InvoiceAddress, InvoiceAddressPopoverProps } from "./types";




const requiredInvoiceAddressKeys: (InvoiceAddressKeys)[] = [
    "notifyLicenseExpiration",
    "ustIdNr",
    "companyName",
    "firstName",
    "address1",
    "zip",
    "country",
    "city",
    "invoiceEmail",
    "lastName"
];

const flatten = (obj: Record<string, any>, obj2: Record<string, any>) =>
{
    Object.entries(obj).forEach(([key, val]) =>
    {
        obj2[key] = val;
    });
    return obj2;
};

export const InvoiceAddressPopover: React.FC<InvoiceAddressPopoverProps>
    = ({
        isOpen,
        onDismiss,
        onData,
    }) =>
    {

        const invoiceAddress = useRef<Partial<InvoiceAddress>>({});
        const [invoiceAddressIsFilledOut, setInvoiceAddressIsFilledOut] = useState(hasRequiredFields(invoiceAddress.current, requiredInvoiceAddressKeys));

        const setInvoiceAddress = useCallback((value: any, type: keyof InvoiceAddress, invoiceAddressIsFilledOut: boolean) =>
        {

            if (value instanceof Object) {
                flatten(value, invoiceAddress.current);
            } else {
                invoiceAddress.current[type] = value;
            }

            const isFullFilled = hasRequiredFields(invoiceAddress.current, requiredInvoiceAddressKeys);

            if (isFullFilled && !invoiceAddressIsFilledOut) setInvoiceAddressIsFilledOut(isFullFilled);
        }, []);


        const { translate: t } = useL10n();
        const mobileView = useIsMobile();

        return mobileView ?

            <IonModal
                id="invoiceAddressModalMobile"
                isOpen={isOpen}
                initialBreakpoint={breakpoint}
                backdropDismiss
                onDidDismiss={onDismiss}
            >

                <IonItem color={"dark"}>
                    <div
                        className={`${style.marginTop} ${style.center} ${style.flexRowReverse} ${style.justifyBetween} ${style.with100} ${style.height100}`}>
                        <IonTitle >
                            <div className={`${style.marginTop} ${style.center} ${style.with90} ${style.height100}`}>
                                {t("[REACT_INVOICE_ADDRESS]")}
                            </div>
                        </IonTitle>
                        <div
                            className={`${style.width10} ${style.height100}`}
                            onClick={onDismiss}
                        >
                            <Icon
                                className={`${style.height100} ${style.width100}`}
                                icon={"close"} />
                        </div>
                    </div>
                </IonItem>
                <IonContent>

                    <div
                        //className={style.contentMobile}
                        style={{ maxHeight: getContentMaxHeight(breakpoint), overflow: "auto" }}
                    >
                        <Content
                            invoiceAddress={invoiceAddress.current}
                            onData={(value, attribute) =>
                            {
                                setInvoiceAddress(value, attribute, invoiceAddressIsFilledOut);
                            }}
                        />
                        <ButtonContainer
                            invoiceAddressIsFilledOut={invoiceAddressIsFilledOut}
                            onDismiss={onDismiss}
                            onClick={() => onData(invoiceAddress.current)}
                        />
                    </div>
                </IonContent>
            </IonModal>
            :
            <IonModal
                id="invoiceAddressPopover"
                isOpen={isOpen}
                className={style.invoicePopover}
                backdropDismiss
                onDidDismiss={onDismiss}
            >
                <IonCardHeader color={"dark"}>
                    <IonTitle >
                        <div className={`${style.marginTop} ${style.center}`}>
                            {t("[REACT_INVOICE_ADDRESS]")}
                        </div>
                    </IonTitle>
                </IonCardHeader>
                <IonCardContent>
                    <div className={`${style.invoiceAddressHeight} ${style.center}`}>
                        <>
                            <div className={`${style.height100} ${style.width100} `}>
                                <div
                                    className={`${style.resetPadding} ${style.height90} ${style.overflow}`}
                                >
                                    <IonGrid>
                                        <IonRow>
                                            <Content
                                                invoiceAddress={invoiceAddress.current}
                                                onData={(value, attribute) =>
                                                {
                                                    setInvoiceAddress(value, attribute, invoiceAddressIsFilledOut);
                                                }}
                                            />
                                        </IonRow>
                                    </IonGrid>
                                </div>
                                <IonItem>
                                    <IonGrid>
                                        <IonRow>
                                            <ButtonContainer
                                                invoiceAddressIsFilledOut={hasRequiredFields(invoiceAddress.current, requiredInvoiceAddressKeys)}
                                                onDismiss={onDismiss}
                                                onClick={() => onData(invoiceAddress.current)}
                                            />
                                        </IonRow>
                                    </IonGrid>
                                </IonItem>
                            </div>
                        </>
                    </div>
                </IonCardContent>
            </IonModal >;
    };